export default "__VITE_ASSET__12704d08__"